import React, { useEffect, useState } from "react";
import "./TestimonialsSection.css";

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbwx6jAA2YUM8qijM3xMTJ3BVHdCFY1XRPBwUhyY2SdsiVFvUMdxUd0rkQUFU2AOf7JC/exec";

function TestimonialsSection() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    fetch(SCRIPT_URL)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          const cleanedData = data.map((item) => ({
            name: item.Name || item.name || "",
            comment: item.Comment || item.comment || "",
            rating: item.Rating || item.rating || 5,
            image: item.Image || item.image || "",
            date: item.Date || item.date || "",
          }));
          setTestimonials(cleanedData);
        }
      })
      .catch((err) => console.error("Error:", err));
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleDateString("en-IN");
  };

  return (
    <section className="testimonials">
      <h2>What Our Customers Say</h2>

      <div className="slider">
        <div className="slide-track">
          {[...testimonials, ...testimonials].map((item, index) => (
            <div className="testi-card" key={index}>
              <div className="testi-img">
                <img
                  src={
                    item.image && item.image.trim() !== ""
                      ? item.image
                      : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                  }
                  alt={item.name}
                />
              </div>

              <div className="stars">
                {"⭐".repeat(Number(item.rating) || 5)}
              </div>

              <p className="comment">
                {item.comment ? `“${item.comment}”` : ""}
              </p>

              <h4 className="name">{item.name}</h4>

              <small className="date">
                {formatDate(item.date)}
              </small>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TestimonialsSection;